import { BaseService } from "./BaseService";

export class PaymentsService extends BaseService {
    // constructor(baseUrl) {
    //     super(baseUrl)
    // }

    getPayments = () => this.get('payments/@self?server=winterust');
}